module.exports = __webpack_public_path__ + "img/certificate_820210118_00.229ea493.jpg";